export const OrderItem = {
    itemName: null,
    count: 0,
    price: 0
};